const TAB = '/mobility' as const;
export const DRIVERS = `${TAB}/drivers` as const;
export const DRIVER_CREATE = `${DRIVERS}/create` as const;
export const DRIVERS_UNIT = (unitId: number) => `${DRIVERS}/${unitId}` as const;
export const DRIVER = (unitId: number, driverId: number) => `${DRIVERS}/${unitId}/${driverId}` as const;
export const DRIVER_UPDATE = (unitId: number, driverId: number) =>
  `${DRIVERS}/${unitId}/${driverId}/update` as const;
export const DRIVER_HISTORY = (unitId: number, driverId: number) =>
  `${DRIVERS}/${unitId}/${driverId}/history` as const;
